import { useIntl } from 'react-intl';
import { Col, Form, FormInstance, Input, Row } from 'antd';

import { useDefaultEmptyFieldError } from '@/hooks';

import { CnpjFormField, FloatingFormItem } from '@/components/_common';
import { InsurerSimplifiedFormData } from '../InsurerSimplifiedRegisterModal';

interface InsurerSimplifiedFormProps {
  form: FormInstance<InsurerSimplifiedFormData>;
}

function InsurerSimplifiedForm({ form }: InsurerSimplifiedFormProps) {
  const intl = useIntl();
  const defaultEmptyFieldError = useDefaultEmptyFieldError();

  return (
    <Form form={form} layout="vertical">
      <Form.Item hidden name="phoneId" />

      <Row gutter={[16, 8]}>
        <Col xs={24} md={12}>
          <FloatingFormItem
            name="name"
            label={intl.formatMessage({ id: 'insurers.general.form.name' })}
            rules={[defaultEmptyFieldError]}
          >
            <Input />
          </FloatingFormItem>
        </Col>

        <Col xs={24} md={12}>
          <FloatingFormItem
            name="fantasyName"
            label={intl.formatMessage({
              id: 'insurers.general.form.fantasyName',
            })}
          >
            <Input />
          </FloatingFormItem>
        </Col>

        <Col xs={24} md={12} lg={8}>
          <CnpjFormField
            fieldName="cnpj"
            label={intl.formatMessage({
              id: 'insurers.general.form.cnpj',
            })}
            required
          />
        </Col>

        <Col span={12}>
          <FloatingFormItem
            name="email"
            label={intl.formatMessage({
              id: 'customers.domain.contact.contactType.email',
            })}
            rules={[
              {
                type: 'email',
                message: intl.formatMessage({
                  id: 'commons.form.errors.invalidEmail',
                }),
              },
            ]}
          >
            <Input />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}

export default InsurerSimplifiedForm;
